import { BudgetRuleClient } from '@frontend/budget/api';
import { EntityType } from '@frontend/common';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useBudgetRule:request': CustomEvent<string>;
    }
}

const REQUEST_BUDGET_RULE_EVENT = 'useBudgetRule:request';
const STORAGE_KEY = 'BUDRU_REQ';

export function budgetRuleRequest(budgetRuleId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_BUDGET_RULE_EVENT, { detail: budgetRuleId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function BudgetRuleResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_BUDGET_RULE_EVENT, EntityType.RULE, (ids) => BudgetRuleClient.resolveBudgetRules(ids), props.dispatch);
    return <></>;
}
